export default __webpack_public_path__ + "static/media/ic_send.93741a38.svg";